module.exports = __webpack_public_path__ + "static/media/background-image@2x.dbe57ca2.jpg";